import { render, staticRenderFns } from "./unqualifiedDamageAction.vue?vue&type=template&id=fa70c07c&scoped=true"
import script from "./unqualifiedDamageAction.vue?vue&type=script&lang=js"
export * from "./unqualifiedDamageAction.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDamageAction.vue?vue&type=style&index=0&id=fa70c07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa70c07c",
  null
  
)

export default component.exports